import styled from "styled-components";

export const _LinkContainer = styled.div`
  background: ${({ theme }) => theme.progressBar};
  transition: all 0.25s;
  flex: 1;

  @media (min-width: 768px) {
    margin: 5px;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
  }

  @media (min-width: 1200px) {
    margin: 5px 10px;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.enabled {
    cursor: pointer;
  }

  &:hover {
    background: ${({ theme }) => theme.progressBarHighlight};
  }

  & a:hover,
  & a:focus {
    text-decoration: none;
  }
`;

export const _Content = styled.span`
  display: flex;
  align-items: center;
  color: white;
  font-size: 12px;
  padding: 10px 5px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  @media (min-width: 768px) {
    padding: 5px 10px;
    font-size: 14px;
  }

  @media (min-width: 1200px) {
    font-size: 16px;
  }
`;

export const _StepIcon = styled.img`
  display: none;

  @media (min-width: 768px) {
    display: block;
    margin: 0px 5px;
    width: 30px;
    height: 30px;
  }

  @media (min-width: 1200px) {
    height: 40px;
    width: 40px;
  }
`;

export const _StepNumber = styled.span`
  margin-right: 2px;
`;
